var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibertyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    rx: 8,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5343_41651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.02 22.3656V24.2244H7V15.7754H8.95902V22.3656H12.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.46 15.7754H13.501V24.2244H15.46V15.7754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4238 19.8433C21.6646 19.6393 21.8564 19.3851 21.9855 19.0992C22.1146 18.8132 22.1777 18.5026 22.1704 18.1897C22.1704 16.7284 20.958 15.7754 19.4648 15.7754H16.9424V17.5906H19.4648C19.9177 17.5906 20.2114 17.9038 20.2114 18.3385C20.2164 18.4371 20.2007 18.5356 20.1651 18.6278C20.1295 18.7201 20.0749 18.804 20.0047 18.8744C19.9346 18.9448 19.8504 19 19.7574 19.0367C19.6645 19.0733 19.5648 19.0906 19.4648 19.0873H18.3776V20.7963H19.7097C20.1994 20.7963 20.518 21.1349 20.518 21.605C20.518 22.0752 20.1994 22.4137 19.7097 22.4137H18.3776V24.2289H19.7097C21.2397 24.2289 22.4761 23.2514 22.4761 21.7548C22.4849 21.3741 22.3924 20.9978 22.2078 20.6634C22.0232 20.329 21.7529 20.0481 21.4238 19.8488",
    fill: "#E03126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3697 22.3656V24.2244H23.9824V15.7754H29.309V17.6342H25.9414V19.0346H29.0024V20.8689H25.9414V22.3656H29.3697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0407 17.6342H41.8368V24.2244H39.8787V17.6342H37.6748V15.7754H44.0407V17.6342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1239 20.9769V24.2244H48.1649V20.9769L45.2871 15.7754H47.5159L49.1444 19.0346L50.772 15.7754H53.0008L50.1239 20.9769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6222 21.1222C35.5649 20.652 36.201 19.7099 36.201 18.6716C36.202 18.291 36.1267 17.914 35.9794 17.5621C35.8321 17.2103 35.6158 16.8907 35.3428 16.6215C35.0698 16.3524 34.7456 16.1391 34.3887 15.9939C34.0319 15.8487 33.6495 15.7744 33.2634 15.7754H30.7373V17.5852H33.2634C33.802 17.5852 34.2429 18.0562 34.2429 18.6743C34.2429 19.2924 33.802 19.7635 33.2634 19.7635H32.0068V21.448H32.7239L34.3414 24.2244H36.4477L34.6222 21.1222Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5343_41651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.0002,
    height: 8.44902,
    fill: "white",
    transform: "translate(7 15.7754)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibertyIcon);
export default __webpack_public_path__ + "static/media/libertyIcon.f41f48fe42e859d22117f5714ee87cb6.svg";
export { ForwardRef as ReactComponent };